(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2937],{

/***/ 37555:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]",
      function () {
        return __webpack_require__(87182);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DirectoryBreadcrumb; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41361);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3__);





// [label, href] pairs; the last one is the current page and is not linked.
function DirectoryBreadcrumb(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        "aria-label": "Breadcrumb",
        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3___default().breadcrumb),
        "data-nosnippet": true,
        children: items.map(function(param, index) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), label = _param[0], href = _param[1];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-hidden": "true",
                        children: "›"
                    }),
                    index < items.length - 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: label
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-current": "page",
                        children: label
                    })
                ]
            }, href);
        })
    });
}


/***/ }),

/***/ 45702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30909);
/* harmony import */ var styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var LoginInfo = function(param) {
    var label = param.label, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: (styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2___default().info),
        tabIndex: 0,
        "aria-label": label,
        "data-nosnippet": true,
        children: [
            "i",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2___default().popover),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        children,
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/login",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Log in"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginInfo);


/***/ }),

/***/ 9999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SmartText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-animate-height/lib/AnimateHeight.js
var AnimateHeight = __webpack_require__(68133);
// EXTERNAL MODULE: ./styles/modules/SmartText.module.scss
var SmartText_module = __webpack_require__(89073);
var SmartText_module_default = /*#__PURE__*/__webpack_require__.n(SmartText_module);
;// CONCATENATED MODULE: ./utils/hydrateLinks.js
var hydrateLinks = function(text) {
    var matches = text.match(/(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi);
    matches === null || matches === void 0 ? void 0 : matches.forEach(function(m) {
        text = text.replace(m, '<a href="'.concat(m, '">').concat(m, "</a>"));
    });
    return text;
};

// EXTERNAL MODULE: ./utils/safe-html.js
var safe_html = __webpack_require__(95460);
;// CONCATENATED MODULE: ./components/SmartText.js







var SmartText = function(param) {
    var quotes = param.quotes, height = param.height, bg = param.bg, className = param.className, change = param.change, data = param.data;
    var ref = (0,react.useState)(false), opened = ref[0], setOpened = ref[1];
    var ref1 = (0,react.useState)("auto"), realHeight = ref1[0], setRealHeight = ref1[1];
    var wrapper = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        wrapper.current.offsetHeight < height ? setRealHeight("auto") : setRealHeight(height);
        setOpened(false);
    }, [
        router,
        change
    ]);
    if (data) {
        data = (0,safe_html/* default */.ZP)(hydrateLinks(data));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimateHeight/* default */.Z, {
                duration: 400,
                height: opened ? "auto" : realHeight,
                className: (SmartText_module_default()).descriptionText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: wrapper,
                        className: [
                            quotes ? (SmartText_module_default()).doubleQuoted : undefined,
                            (SmartText_module_default()).data, 
                        ].join(" "),
                        dangerouslySetInnerHTML: {
                            __html: data
                        }
                    }),
                    realHeight !== "auto" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            (SmartText_module_default()).shadow,
                            className,
                            opened ? (SmartText_module_default()).shadowOpened : undefined, 
                        ].join(" "),
                        style: {
                            background: bg && "linear-gradient(to top, ".concat(bg, " 0%, rgba(255, 255, 255, 0) 100%)")
                        }
                    })
                ]
            }),
            realHeight !== "auto" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (SmartText_module_default()).link,
                onClick: function() {
                    return setOpened(!opened);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: opened ? (SmartText_module_default()).opened : undefined,
                    "data-nosnippet": true,
                    children: opened ? "Read less" : "Read more"
                })
            })
        ]
    });
};
/* harmony default export */ var components_SmartText = (SmartText);


/***/ }),

/***/ 46975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styles_modules_TitleUnderline_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23619);
/* harmony import */ var styles_modules_TitleUnderline_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styles_modules_TitleUnderline_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var TitleUnderline = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            (styles_modules_TitleUnderline_module_scss__WEBPACK_IMPORTED_MODULE_1___default().title),
            className !== null && className !== void 0 ? className : null
        ].join(" "),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TitleUnderline);


/***/ }),

/***/ 87182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _company_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./next-seo.config.js
var next_seo_config = __webpack_require__(5056);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./store/ux.js
var ux = __webpack_require__(30807);
// EXTERNAL MODULE: ./styles/modules/ProfileHeader.module.scss
var ProfileHeader_module = __webpack_require__(52987);
var ProfileHeader_module_default = /*#__PURE__*/__webpack_require__.n(ProfileHeader_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/modules/ProfileBio.module.scss
var ProfileBio_module = __webpack_require__(53609);
var ProfileBio_module_default = /*#__PURE__*/__webpack_require__.n(ProfileBio_module);
// EXTERNAL MODULE: ./components/SmartText.js + 1 modules
var SmartText = __webpack_require__(9999);
// EXTERNAL MODULE: ./components/Svg/Facebook.js
var Facebook = __webpack_require__(81361);
// EXTERNAL MODULE: ./components/Svg/Instagram.js
var Instagram = __webpack_require__(51977);
// EXTERNAL MODULE: ./components/Svg/LinkedIn.js
var LinkedIn = __webpack_require__(26908);
// EXTERNAL MODULE: ./components/Svg/Twitter.js
var Twitter = __webpack_require__(15288);
// EXTERNAL MODULE: ./components/Svg/Youtube.js
var Youtube = __webpack_require__(68246);
// EXTERNAL MODULE: ./components/Svg/Tiktok.js
var Tiktok = __webpack_require__(24306);
// EXTERNAL MODULE: ./components/Svg/Mastodon.js
var Mastodon = __webpack_require__(11340);
// EXTERNAL MODULE: ./components/Svg/Threads.js
var Threads = __webpack_require__(84591);
;// CONCATENATED MODULE: ./components/SocialLink.js










var SocialLink = function(props) {
    var name = props.name, url = props.url;
    if (!name || !url) return null;
    var icon;
    switch(name){
        case "facebook":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {
                fill: "#000"
            });
            break;
        case "instagram":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Instagram/* default */.Z, {
                fill: "#000"
            });
            break;
        case "linkedin":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn/* default */.Z, {
                fill: "#000"
            });
            break;
        case "twitter":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                fill: "#000"
            });
            break;
        case "youtube":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Youtube/* default */.Z, {
                fill: "#000"
            });
            break;
        case "tiktok":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiktok/* default */.Z, {
                fill: "#212121"
            });
            break;
        case "mastodon":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Mastodon/* default */.Z, {
                fill: "#212121"
            });
            break;
        case "threads":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Threads/* default */.Z, {
                fill: "#212121"
            });
            break;
        default:
            icon = null;
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            children: icon
        })
    });
};
/* harmony default export */ var components_SocialLink = (SocialLink);

// EXTERNAL MODULE: ./components/Svg/World.js
var World = __webpack_require__(99318);
// EXTERNAL MODULE: ./components/Profile/AddContent.js
var Profile_AddContent = __webpack_require__(93045);
// EXTERNAL MODULE: ./components/Profile/EditContent.js
var EditContent = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./store/company/expertise.js
var expertise = __webpack_require__(44362);
// EXTERNAL MODULE: ./store/expertise.js
var store_expertise = __webpack_require__(781);
// EXTERNAL MODULE: ./components/ExpertiseDropdown.js + 1 modules
var ExpertiseDropdown = __webpack_require__(25680);
// EXTERNAL MODULE: ./components/Tags.js
var Tags = __webpack_require__(58632);
// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
// EXTERNAL MODULE: ./store/auth.js
var store_auth = __webpack_require__(32505);
// EXTERNAL MODULE: ./store/company/index.js
var store_company = __webpack_require__(3383);
// EXTERNAL MODULE: ./components/Typo.js
var components_Typo = __webpack_require__(23775);
// EXTERNAL MODULE: ./hooks/useFitCount.js
var useFitCount = __webpack_require__(16988);
;// CONCATENATED MODULE: ./components/Profile/Expertise.js

















// The chip may stretch to fill its row, so its natural size is the label plus
// its own padding, border and trailing margin.
var chipWidth = function(chip) {
    var style = getComputedStyle(chip);
    return [
        "paddingLeft",
        "paddingRight",
        "borderLeftWidth",
        "borderRightWidth",
        "marginRight", 
    ].reduce(function(width, property) {
        return width + parseFloat(style[property]);
    }, chip.firstElementChild.scrollWidth);
};
var Expertise = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var isAuthorized = (0,es/* useSelector */.v9)(store_auth/* authSelector */.aF).isAuthorized;
    var ref = (0,es/* useSelector */.v9)(store_expertise/* expertiseSelector */._H), globalExpertise = ref.data;
    var id = (0,es/* useSelector */.v9)(store_company/* companySelector */.yX).data.id;
    var ref1 = (0,es/* useSelector */.v9)(expertise/* companyExpertiseSelector */.hf), data = ref1.data, profileId = ref1.profileId;
    var companyExpertise = profileId === id ? data : null;
    var ref2 = (0,react.useState)(false), activeAdder = ref2[0], setActiveAdder = ref2[1];
    var ref3 = (0,react.useState)(false), expanded = ref3[0], setExpanded = ref3[1];
    var rowRef = (0,react.useRef)(null);
    var tagsRef = (0,react.useRef)(null);
    var moreRef = (0,react.useRef)(null);
    var ref4;
    var visible = (0,useFitCount/* default */.Z)({
        rowRef: rowRef,
        buttonRef: moreRef,
        measure: function() {
            return (0,_to_consumable_array/* default */.Z)(tagsRef.current.children).map(chipWidth);
        },
        total: (ref4 = companyExpertise === null || companyExpertise === void 0 ? void 0 : companyExpertise.length) !== null && ref4 !== void 0 ? ref4 : 0,
        max: 5,
        key: companyExpertise === null || companyExpertise === void 0 ? void 0 : companyExpertise.map(function(tag) {
            return tag.id;
        }).join(),
        enabled: !expanded
    });
    (0,react.useEffect)(function() {
        var ref, ref1;
        var chip = (ref1 = (ref = tagsRef.current) === null || ref === void 0 ? void 0 : ref.children[visible]) === null || ref1 === void 0 ? void 0 : ref1.firstElementChild;
        if (!expanded || !chip) return;
        // The chip label is a plain span, which can't take focus without this.
        chip.tabIndex = -1;
        chip.focus();
    }, [
        expanded
    ]);
    (0,react.useEffect)(function() {
        if (id && profileId !== id) {
            dispatch((0,expertise/* fetchExpertise */.P0)(id));
        }
        if (!globalExpertise) {
            dispatch((0,store_expertise/* fetchExpertise */.P0)());
        }
    }, [
        id,
        profileId,
        globalExpertise
    ]);
    if (!companyExpertise) {
        return null;
    }
    var tagRow = companyExpertise.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: rowRef,
        className: [
            (ProfileBio_module_default()).tagRow,
            expanded ? (ProfileBio_module_default()).tagRowExpanded : "", 
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: tagsRef,
                className: (ProfileBio_module_default()).tagRowList,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* default */.Z, {
                    data: {
                        activeTags: companyExpertise,
                        onClick: function(param) {
                            var id = param.id;
                            dispatch((0,expertise/* removeExpertise */.kA)(id));
                        },
                        limit: companyExpertise.length,
                        visible: expanded ? companyExpertise.length : visible
                    }
                })
            }),
            !expanded && visible < companyExpertise.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                ref: moreRef,
                type: "button",
                "aria-expanded": "false",
                onClick: function() {
                    return setExpanded(true);
                },
                className: (ProfileBio_module_default()).loadMore,
                children: "+".concat(companyExpertise.length - visible, " more")
            })
        ]
    });
    if (!isAuthorized) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
            className: [
                "mb-l",
                (ProfileBio_module_default()).list,
                (ProfileBio_module_default()).listOneRow
            ].join(" "),
            "data-nosnippet": true,
            children: tagRow || /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "This company ",
                    "hasn't",
                    " added any areas of expertise yet"
                ]
            })
        });
    }
    var adderRef = /*#__PURE__*/ (0,react.createRef)();
    var dropdownData = {
        name: "expertise",
        inline: false,
        items: globalExpertise || [],
        exclude: companyExpertise,
        callback: function(item) {
            if (companyExpertise.find(function(ce) {
                return ce.id === item.id || ce.name === item.name;
            })) {
                return;
            }
            dispatch((0,expertise/* addExpertise */.Kv)(item));
            // A new tag goes on the end, which a collapsed row would hide.
            setExpanded(true);
        }
    };
    if (!activeAdder) {
        dropdownData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dropdownData), {
            query: "",
            showList: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: [
            "mb-l",
            (ProfileBio_module_default()).list,
            (ProfileBio_module_default()).listOneRow
        ].join(" "),
        ref: adderRef,
        children: [
            tagRow,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    (ProfileBio_module_default()).addTag,
                    activeAdder ? (ProfileBio_module_default()).addTagActive : null, 
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProfileBio_module_default()).dropdown,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertiseDropdown/* default */.Z, {
                            data: dropdownData
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProfileBio_module_default()).add,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_AddContent/* default */.Z, {
                            data: {
                                direction: "row",
                                label: activeAdder || companyExpertise && companyExpertise.length > 6 ? "" : en/* profile.header.expertise.button */.N5.Fs.yU.L,
                                active: activeAdder,
                                onClick: function() {
                                    setActiveAdder(!activeAdder);
                                }
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Profile_Expertise = (Expertise);

// EXTERNAL MODULE: ./store/company/expert.js
var expert = __webpack_require__(17390);
// EXTERNAL MODULE: ./components/Svg/Star.js
var Svg_Star = __webpack_require__(76997);
;// CONCATENATED MODULE: ./components/Svg/Avatar.js

function Chat() {
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 480 480",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M240 8C111.872 8 8 111.872 8 240c0 56.256 20.032 107.824 53.336 147.992 15.512-63.176 63.688-113.384 125.552-132.04C161.048 238.744 144 209.376 144 176c0-53.016 42.984-96 96-96s96 42.984 96 96c0 33.376-17.048 62.744-42.896 79.952 61.864 18.656 110.04 68.864 125.552 132.04C451.968 347.824 472 296.256 472 240 472 111.872 368.128 8 240 8z",
                fill: "#efece8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M293.104 255.952C318.952 238.744 336 209.376 336 176c0-53.016-42.984-96-96-96s-96 42.984-96 96c0 33.376 17.048 62.744 42.896 79.952-61.864 18.656-110.04 68.864-125.552 132.04 0 0 0 .008.008.008a237.163 237.163 0 007.832 8.944c.648.712 1.328 1.392 1.992 2.088a239.937 239.937 0 006.296 6.464c.888.872 1.792 1.712 2.696 2.568a233.567 233.567 0 006.04 5.568c1.016.896 2.048 1.784 3.072 2.664 2.008 1.72 4.04 3.408 6.112 5.056 1.088.872 2.184 1.728 3.28 2.584a214.91 214.91 0 006.376 4.72c1.112.792 2.208 1.6 3.336 2.376 2.272 1.568 4.584 3.072 6.912 4.56 1.048.664 2.072 1.352 3.128 2.008a237.722 237.722 0 008.184 4.792c.728.408 1.44.848 2.176 1.248a231.937 231.937 0 0010.872 5.592c.088.04.184.08.272.12 3.512 1.68 7.08 3.272 10.688 4.776 1.12.472 2.264.888 3.392 1.336 2.608 1.04 5.216 2.064 7.872 3.008 1.408.504 2.832.96 4.248 1.44 2.416.816 4.848 1.608 7.296 2.336 1.552.464 3.112.896 4.68 1.328 2.368.656 4.752 1.28 7.16 1.864a219.555 219.555 0 0012.152 2.584c1.648.304 3.288.616 4.952.88 2.512.408 5.04.752 7.576 1.08 1.6.208 3.192.44 4.8.608 2.8.304 5.624.52 8.448.72 1.368.096 2.72.24 4.088.312 4.216.24 8.448.376 12.72.376s8.504-.136 12.72-.36c1.368-.072 2.728-.216 4.088-.312 2.832-.2 5.656-.416 8.448-.72 1.608-.176 3.2-.4 4.8-.608 2.536-.328 5.064-.672 7.576-1.08 1.656-.272 3.304-.576 4.952-.88a215.477 215.477 0 0012.152-2.584c2.4-.584 4.784-1.208 7.16-1.864 1.56-.432 3.128-.864 4.68-1.328 2.456-.736 4.88-1.528 7.296-2.336 1.416-.48 2.848-.936 4.248-1.44a245.374 245.374 0 007.872-3.008c1.128-.448 2.272-.872 3.392-1.336a226.642 226.642 0 0010.64-4.76c.104-.048.216-.096.32-.144 3.68-1.768 7.304-3.64 10.872-5.592.736-.4 1.448-.84 2.176-1.248a237.722 237.722 0 008.184-4.792c1.056-.648 2.088-1.336 3.128-2.008 2.328-1.488 4.64-3 6.912-4.56 1.12-.776 2.224-1.576 3.336-2.376a247.51 247.51 0 006.376-4.72 202.128 202.128 0 003.28-2.584 230.055 230.055 0 006.112-5.056c1.032-.88 2.064-1.768 3.072-2.664a233.567 233.567 0 006.04-5.568c.896-.856 1.808-1.704 2.696-2.568a228.37 228.37 0 006.296-6.464c.656-.704 1.336-1.384 1.992-2.088 2.68-2.92 5.304-5.896 7.832-8.944 0 0 0-.008.008-.008-15.504-63.184-63.68-113.4-125.552-132.048z",
                fill: "#c6c3bd"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M240 0C107.664 0 0 107.664 0 240c0 57.96 20.656 111.184 54.992 152.704.088.12.096.272.192.384 24.792 29.896 55.928 52.816 90.624 67.624.4.168.792.352 1.192.52 2.808 1.184 5.648 2.28 8.496 3.352 1.12.424 2.24.856 3.376 1.264 2.456.88 4.928 1.712 7.416 2.512 1.592.512 3.184 1.016 4.792 1.496 2.2.656 4.408 1.288 6.632 1.888 1.952.528 3.92 1.016 5.888 1.488 1.992.48 3.992.96 6 1.384 2.24.48 4.504.904 6.776 1.32 1.824.336 3.64.688 5.48.984 2.52.408 5.056.728 7.6 1.056 1.64.208 3.272.448 4.92.624 2.88.304 5.784.52 8.696.72 1.352.096 2.696.24 4.056.312 4.248.24 8.544.368 12.872.368s8.624-.128 12.888-.352c1.36-.072 2.704-.216 4.056-.312 2.912-.208 5.816-.416 8.696-.72 1.648-.176 3.28-.416 4.92-.624 2.544-.328 5.08-.648 7.6-1.056 1.832-.296 3.656-.648 5.48-.984 2.264-.416 4.528-.84 6.776-1.32 2.008-.432 4-.904 6-1.384 1.968-.48 3.936-.968 5.888-1.488a232.661 232.661 0 0011.424-3.384c2.488-.8 4.96-1.632 7.416-2.512 1.128-.408 2.248-.84 3.376-1.264a243.168 243.168 0 008.496-3.352c.4-.168.792-.352 1.192-.52a239.997 239.997 0 0090.624-67.624c.096-.112.104-.272.192-.384C459.344 351.184 480 297.96 480 240 480 107.664 372.336 0 240 0zm47.872 249.736a84.742 84.742 0 01-9.8 5.48c-.4.192-.792.392-1.192.576-23.168 10.536-50.592 10.536-73.76 0-.4-.184-.8-.384-1.192-.576a84.083 84.083 0 01-9.8-5.48C168.008 234.024 152 206.864 152 176c0-48.52 39.48-88 88-88s88 39.48 88 88c0 30.864-16.008 58.024-40.128 73.736zm-98.72 16.896c.672.376 1.336.776 2.016 1.136a99.592 99.592 0 007.272 3.512c1.896.832 3.856 1.536 5.808 2.256.384.136.768.288 1.152.424 10.848 3.84 22.456 6.04 34.6 6.04 12.144 0 23.752-2.2 34.592-6.04.384-.136.768-.288 1.152-.424 1.952-.72 3.912-1.424 5.808-2.256a99.592 99.592 0 007.272-3.512c.68-.368 1.344-.76 2.016-1.136 1.144-.64 2.312-1.248 3.432-1.936 56.32 18.272 100.088 64.176 115.56 121.112-20.008 23.272-44.664 42.44-72.576 55.952-.12.056-.232.12-.352.176-2.856 1.376-5.76 2.672-8.688 3.936-.664.28-1.32.568-1.984.848a217.023 217.023 0 01-7.76 3.064 159.85 159.85 0 01-3.272 1.192 230.572 230.572 0 01-6.976 2.368c-1.456.464-2.92.904-4.384 1.336a202.08 202.08 0 01-6.28 1.784c-1.776.472-3.568.904-5.36 1.328-1.88.448-3.752.904-5.648 1.304-2.072.44-4.16.816-6.24 1.192-1.688.312-3.368.64-5.072.912-2.344.368-4.712.664-7.072.96-1.496.192-2.984.416-4.496.576-2.696.288-5.416.472-8.128.664-1.208.08-2.408.216-3.632.28-3.96.208-7.928.32-11.912.32s-7.952-.112-11.904-.32c-1.216-.064-2.416-.192-3.632-.28-2.72-.184-5.432-.376-8.128-.664-1.512-.16-3-.384-4.496-.576-2.36-.296-4.728-.592-7.072-.96-1.704-.272-3.384-.6-5.072-.912-2.088-.376-4.176-.76-6.24-1.192-1.896-.4-3.776-.856-5.648-1.304-1.792-.432-3.584-.856-5.36-1.328-2.104-.56-4.2-1.168-6.28-1.784a212.543 212.543 0 01-4.384-1.336 223.256 223.256 0 01-6.976-2.368 217.023 217.023 0 01-11.032-4.256c-.664-.272-1.312-.56-1.976-.84a223.812 223.812 0 01-8.696-3.936 7.216 7.216 0 01-.352-.176c-27.912-13.504-52.568-32.672-72.576-55.952 15.464-56.944 59.24-102.848 115.56-121.112 1.112.68 2.272 1.288 3.416 1.928zm232.68 103.952c-18.136-53.552-59.512-96.832-112.376-117.392C330.6 234.144 344 206.64 344 176c0-57.344-46.656-104-104-104s-104 46.656-104 104c0 30.64 13.4 58.144 34.552 77.192-52.864 20.568-94.24 63.84-112.376 117.392C31.672 333.792 16 288.704 16 240 16 116.488 116.488 16 240 16s224 100.488 224 224c0 48.704-15.672 93.792-42.168 130.584z",
                fill: "#4b413a"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Expert.js






var Expert_Expert = function(props) {
    var isAuthorized = useSelector(authSelector).isAuthorized;
    var _data = props.data, item = _data.item, key = _data.key;
    var onClick = props.onClick, onElementClick = props.onElementClick, expertToRemoveFake = props.expertToRemoveFake;
    var handleOnClick = function(item) {
        if (onClick) {
            onClick(item);
        }
    };
    var handleProfile = function(item) {
        if (onElementClick) {
            onElementClick(item);
        }
    };
    if (expertToRemoveFake && expertToRemoveFake.id === item.id) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.expert,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.image,
                onClick: function() {
                    return handleProfile(item);
                },
                children: item.image ? /*#__PURE__*/ _jsx("img", {
                    src: item.image.path
                }) : /*#__PURE__*/ _jsx(Avatar, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.body,
                onClick: function() {
                    return handleProfile(item);
                },
                children: [
                    /*#__PURE__*/ _jsx(Typo, {
                        variant: "caption",
                        children: item.name
                    }),
                    /*#__PURE__*/ _jsx(Typo, {
                        variant: "small",
                        children: item.position
                    })
                ]
            }),
            isAuthorized && /*#__PURE__*/ _jsx("button", {
                className: styles.remove,
                onClick: function() {
                    return handleOnClick(item);
                },
                children: "Remove"
            })
        ]
    }, "expert-".concat(key));
};
/* harmony default export */ var components_Expert = ((/* unused pure expression or super */ null && (Expert_Expert)));

// EXTERNAL MODULE: ./components/Button.js + 2 modules
var components_Button = __webpack_require__(44217);
;// CONCATENATED MODULE: ./components/popUps/ActionConfirm.js




var ActionConfirm_ActionConfirm = function(param) {
    var expertToRemove = param.expertToRemove, onRemove = param.onRemove, onCancel = param.onCancel;
    if (!expertToRemove) return null;
    var handleConfirm = function() {
        if (onRemove) {
            onRemove();
        }
    };
    var handleCancel = function() {
        if (onCancel) {
            onCancel();
        }
    };
    var avatar = expertToRemove.imageUrl ? /*#__PURE__*/ _jsx("div", {
        className: styles.avatar,
        style: {
            backgroundImage: "url(".concat(expertToRemove.imageUrl, ")")
        }
    }) : /*#__PURE__*/ _jsx(Avatar, {});
    return /*#__PURE__*/ _jsx("div", {
        className: styles.wrapper,
        children: expertToRemove && /*#__PURE__*/ _jsxs("div", {
            className: styles.popUp,
            children: [
                /*#__PURE__*/ _jsxs("h4", {
                    className: styles.title,
                    children: [
                        "Are you sure you want to delete",
                        /*#__PURE__*/ _jsx("br", {}),
                        expertToRemove.name,
                        " from your NewsPage?"
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.expert,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.image,
                            children: avatar
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.titlesWrapper,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.name,
                                    children: expertToRemove.name
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.position,
                                    children: expertToRemove.position
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.buttonWrapper,
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            title: "Cancel",
                            onClick: handleCancel,
                            classes: [
                                styles.cancelButton
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            title: "Confirm",
                            onClick: handleConfirm,
                            classes: [
                                styles.confirmButton
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var popUps_ActionConfirm = ((/* unused pure expression or super */ null && (ActionConfirm_ActionConfirm)));

;// CONCATENATED MODULE: ./components/Profile/Experts.js



















var Experts = function() {
    var ref = useSelector(authSelector), isAuthorized = ref.isAuthorized, company = ref.company;
    var ref1 = useSelector(companySelector), plan = ref1.data.plan;
    var dispatch = useDispatch();
    var ref2 = useSelector(expertSelector), data = ref2.data, expert = ref2.expert;
    var ref3 = useState(false), expertToRemove = ref3[0], setExpertToRemove = ref3[1];
    var ref4 = useState(null), expertToRemoveFake = ref4[0], setExpertToRemoveFake = ref4[1];
    var ref5 = useState((plan === null || plan === void 0 ? void 0 : plan.type) === "free" ? 2 : 5), limit = ref5[0], setLimit = ref5[1];
    useEffect(function() {
        if (!data) {
            dispatch(fetchExperts());
        }
        setLimit(plan.type === "free" ? 2 : 5);
    }, [
        data
    ]);
    if (!data) {
        return null;
    }
    var expertsList = data ? data.slice(0, limit).map(function(expert, key) {
        return /*#__PURE__*/ _jsx(Expert, {
            onClick: function(expert) {
                setExpertToRemove(expert);
                setExpertToRemoveFake(expert);
                dispatch(showOverlay());
            },
            data: {
                item: expert,
                key: key
            },
            onElementClick: function(item) {
                handleEditExpert(item.id);
            },
            isEditable: function(tag) {
                return tag;
            },
            expertToRemoveFake: expertToRemoveFake
        }, key);
    }) : null;
    var removePopUp = /*#__PURE__*/ _jsx(ActionConfirm, {
        activeTags: data,
        expertToRemove: expertToRemove,
        onRemove: /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch(removeExpert(expertToRemove.id))
                        ];
                    case 1:
                        _state.sent();
                        setExpertToRemove(false);
                        dispatch(hideOverlay());
                        return [
                            2
                        ];
                }
            });
        }),
        onCancel: function() {
            setExpertToRemove(false);
            setExpertToRemoveFake(null);
            dispatch(hideOverlay());
        }
    });
    var handleAddExpert = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch(resetExpertData())
                        ];
                    case 1:
                        _state.sent();
                        dispatch(handleShowSidescreen("add-expert"));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddExpert() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEditExpert = function() {
        var _ref = _async_to_generator(function(id) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!expert || expert.id !== id)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch(handleFindExpert(id))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        dispatch(handleShowSidescreen("edit-expert"));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleEditExpert(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadingPlaceholder = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: [
                    expertStyles.expert,
                    "loadingText"
                ].join(" "),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: expertStyles.image,
                        children: /*#__PURE__*/ _jsx(Avatar, {})
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: expertStyles.body,
                        children: [
                            /*#__PURE__*/ _jsx(Typo, {
                                variant: "caption",
                                children: "Loading expert"
                            }),
                            /*#__PURE__*/ _jsx(Typo, {
                                variant: "small",
                                children: "Loading expert"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: [
                    expertStyles.expert,
                    "loadingText"
                ].join(" "),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: expertStyles.image,
                        children: /*#__PURE__*/ _jsx(Avatar, {})
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: expertStyles.body,
                        children: [
                            /*#__PURE__*/ _jsx(Typo, {
                                variant: "caption",
                                children: "Loading expert"
                            }),
                            /*#__PURE__*/ _jsx(Typo, {
                                variant: "small",
                                children: "Loading expert"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    var loadMore = (plan === null || plan === void 0 ? void 0 : plan.type) !== "free" && limit < data.length && /*#__PURE__*/ _jsx("button", {
        onClick: function() {
            return setLimit(plan.type === "free" ? 2 : data.length);
        },
        className: [
            styles.loadMore
        ],
        children: "+".concat(data.length - limit, " more")
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            removePopUp,
            /*#__PURE__*/ _jsx("aside", {
                className: [
                    "mb-l",
                    styles.list
                ].join(" "),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.listExperts,
                    children: [
                        data ? expertsList.length > 0 || isAuthorized ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                expertsList,
                                " ",
                                loadMore
                            ]
                        }) : /*#__PURE__*/ _jsx(Typo, {
                            className: styles.empty,
                            children: "This company hasn't added any experts yet"
                        }) : loadingPlaceholder,
                        isAuthorized && plan.type === "free" && data.length > 1 ? /*#__PURE__*/ _jsxs("div", {
                            className: styles.premium,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.icon,
                                    children: /*#__PURE__*/ _jsx(Star, {})
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.premiumText,
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            href: "/".concat(company, "/subscription"),
                                            className: styles.premiumLink,
                                            children: "Upgrade to Plus"
                                        }),
                                        /*#__PURE__*/ _jsx(Typo, {
                                            variant: "small",
                                            children: "to add/see more experts."
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(AddContent, {
                            data: {
                                direction: "row",
                                label: profile.header.experts.label,
                                onClick: handleAddExpert
                            }
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Profile_Experts = ((/* unused pure expression or super */ null && (Experts)));

// EXTERNAL MODULE: ./components/CreditsDisplay.js
var CreditsDisplay = __webpack_require__(50253);
// EXTERNAL MODULE: ./components/Svg/Tick.js
var Tick = __webpack_require__(98948);
// EXTERNAL MODULE: ./components/Svg/Shield.js
var Shield = __webpack_require__(79344);
// EXTERNAL MODULE: ./components/Svg/diamond.js
var diamond = __webpack_require__(5019);
// EXTERNAL MODULE: ./utils/pluralize.js
var pluralize = __webpack_require__(68545);
// EXTERNAL MODULE: ./utils/fca.js
var fca = __webpack_require__(34320);
;// CONCATENATED MODULE: ./components/Profile/ProfileBio.js























var ProfileBio = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref7 = (0,react.useState)(props.data), data = ref7[0], setData = ref7[1];
    var auth = (0,es/* useSelector */.v9)(store_auth/* authSelector */.aF);
    (0,react.useEffect)(function() {
        setData(props.data);
    }, [
        props.data
    ]);
    // Raws count for experts; journalists post alerts as part of the job.
    var showRaws = data.rawsCount > 0 && !data.isJournalist;
    var handleEditInfo = function() {
        dispatch((0,ux/* handleShowSidescreen */.Co)("edit-info"));
    };
    var handleEditDescription = function() {
        dispatch((0,ux/* handleShowSidescreen */.Co)("edit-description"));
    };
    // Check if credits should be shown (same logic as CreditsDisplay)
    var shouldShowCredits = auth.isAuthenticated && ((ref = data.plan) === null || ref === void 0 ? void 0 : ref.type) !== "free" && ((ref1 = data.plan) === null || ref1 === void 0 ? void 0 : ref1.type) !== "platinum" && !auth.isContributingEditor;
    var badgeConfig = [
        {
            key: "contributing_editor",
            condition: ((ref2 = data.plan) === null || ref2 === void 0 ? void 0 : ref2.type) === "contributing_editor",
            Icon: Svg_Star/* default */.Z,
            label: "Pro",
            className: (ProfileBio_module_default()).badgeEditor
        },
        {
            key: "platinum",
            condition: ((ref3 = data.plan) === null || ref3 === void 0 ? void 0 : ref3.type) === "platinum",
            Icon: diamond/* default */.Z,
            label: "Platinum",
            className: (ProfileBio_module_default()).badgePlatinum
        },
        {
            key: "premium",
            condition: ((ref4 = data.plan) === null || ref4 === void 0 ? void 0 : ref4.type) === "premium",
            Icon: Svg_Star/* default */.Z,
            label: "Plus",
            className: (ProfileBio_module_default()).badgePremium
        },
        {
            key: "fteditor",
            condition: data.isFTEditor,
            Icon: Svg_Star/* default */.Z,
            label: "FT Editor",
            className: (ProfileBio_module_default()).badgeFTEditor
        },
        {
            key: "admin",
            condition: data.isAdmin,
            Icon: Svg_Star/* default */.Z,
            label: "Admin",
            className: (ProfileBio_module_default()).badgeAdmin
        },
        {
            key: "verified",
            condition: data.isVerified,
            Icon: Tick/* default */.Z,
            // Tick defaults to #212121, unlike Star which already defaults to white.
            iconProps: {
                fill: "#fff"
            },
            label: "Verified",
            className: (ProfileBio_module_default()).badgeVerified
        },
        {
            key: "fca",
            condition: !data.isJournalist && (0,fca/* hasFca */.gM)(data.fca),
            Icon: Shield/* default */.Z,
            label: fca/* FCA_LABEL */.hx,
            className: (ProfileBio_module_default()).badgeFca,
            title: (0,fca/* checkedLine */.Ku)(data.fca)
        },
        {
            key: "journalist",
            condition: data.isJournalist,
            Icon: Svg_Star/* default */.Z,
            label: "Journalist",
            className: (ProfileBio_module_default()).badgeJournalist
        }, 
    ];
    var badges = badgeConfig.filter(function(badge) {
        return badge.condition;
    }).map(function(param) {
        var key = param.key, Icon = param.Icon, label = param.label, className = param.className, iconProps = param.iconProps, title = param.title;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: [
                (ProfileBio_module_default()).badge,
                className
            ].join(" "),
            title: title,
            children: [
                Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, (0,_object_spread/* default */.Z)({}, iconProps)),
                label
            ]
        }, key);
    });
    var evidence = !data.isJournalist && (0,fca/* fcaEvidence */.ok)(data.fca);
    var about = ((ref5 = props.aboutWithCount) === null || ref5 === void 0 ? void 0 : ref5.from) === data.description && props.aboutWithCount.html || data.description;
    // A Raws count on its own keeps its place below the employer.
    var claimUnderName = Boolean(props.coverageClaim);
    var claim = (props.coverageClaim || showRaws) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "".concat((ProfileBio_module_default()).coverageClaim, " ").concat(claimUnderName ? (ProfileBio_module_default()).coverageClaimUnderName : ""),
        children: [
            showRaws && props.coverageClaim ? "".concat(props.coverageClaim.replace(/\.$/, ""), " \xb7 ") : props.coverageClaim,
            showRaws && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                title: "News Alerts the Newspage news team judged strong enough for journalists to run.",
                children: [
                    data.rawsCount,
                    " ",
                    (0,pluralize/* default */.Z)(data.rawsCount, "Raw")
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (ProfileBio_module_default()).bio,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: (ProfileBio_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProfileBio_module_default()).headerContent,
                        children: [
                            badges.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProfileBio_module_default()).badges,
                                children: [
                                    badges,
                                    evidence && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ProfileBio_module_default()).fcaEvidence,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: evidence.href,
                                                        target: "_blank",
                                                        rel: "nofollow noopener",
                                                        children: [
                                                            "FRN ",
                                                            evidence.frn
                                                        ]
                                                    }),
                                                    " \xb7 ".concat(evidence.checked)
                                                ]
                                            }),
                                            evidence.principal && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: evidence.principal
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                                variant: "h1",
                                Tag: "h1",
                                font: "serif",
                                className: (ProfileBio_module_default()).title,
                                children: data.name || auth.isJournalist === true && "Your name" || "Your company name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditContent/* default */.Z, {
                                data: {
                                    style: "withLabel",
                                    label: "Edit info",
                                    onClick: handleEditInfo
                                }
                            })
                        ]
                    }),
                    claimUnderName && claim,
                    shouldShowCredits && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProfileBio_module_default()).creditsSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditsDisplay/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileBio_module_default()).position,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartText/* default */.Z, {
                    quotes: false,
                    height: 150,
                    className: (ProfileBio_module_default()).smart,
                    change: data.position,
                    data: data.position
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileBio_module_default()).employer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartText/* default */.Z, {
                    quotes: false,
                    height: 150,
                    className: (ProfileBio_module_default()).smart,
                    change: data.employer,
                    data: data.employer
                })
            }),
            !claimUnderName && claim,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProfileBio_module_default()).description,
                children: [
                    !data.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_AddContent/* default */.Z, {
                        data: {
                            direction: "row",
                            label: auth.isJournalist === true && "Add a short bio. One sentence will do!" || "Add your company or personal description",
                            onClick: handleEditDescription
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartText/* default */.Z, {
                        quotes: false,
                        height: 150,
                        className: (ProfileBio_module_default()).smart,
                        change: data.description,
                        data: about
                    })
                ]
            }),
            data.publication && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                variant: "h1",
                Tag: "h2",
                font: "serif",
                className: (ProfileBio_module_default()).mediaTitle,
                children: data.publication
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileBio_module_default()).contacts,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row rowVc rowSb",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ProfileBio_module_default()).contactsWebsite,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ProfileBio_module_default()).contactsIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(World/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ProfileBio_module_default()).contactsOutput,
                                    children: data.website && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: data.website.includes("http") ? data.website : "https://".concat(data.website),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: data.website
                                        })
                                    })
                                })
                            ]
                        }),
                        ((ref6 = data.socialNetwork) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProfileBio_module_default()).contactsSocial,
                            children: data.socialNetwork.map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SocialLink, {
                                    name: item.name,
                                    url: item.url
                                }, "social-link-".concat(key));
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "row",
                    "mt-xl",
                    (ProfileBio_module_default()).lists
                ].join(" "),
                children: data.isJournalist === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_Expertise, {}, data.slug)
            })
        ]
    });
};
/* harmony default export */ var Profile_ProfileBio = (ProfileBio);

// EXTERNAL MODULE: ./styles/modules/ProfileSidebar.module.scss
var ProfileSidebar_module = __webpack_require__(7878);
var ProfileSidebar_module_default = /*#__PURE__*/__webpack_require__.n(ProfileSidebar_module);
// EXTERNAL MODULE: ./styles/modules/ProfileSidebarAddress.module.scss
var ProfileSidebarAddress_module = __webpack_require__(72436);
var ProfileSidebarAddress_module_default = /*#__PURE__*/__webpack_require__.n(ProfileSidebarAddress_module);
// EXTERNAL MODULE: ./components/LoginInfo.js
var LoginInfo = __webpack_require__(45702);
;// CONCATENATED MODULE: ./components/Profile/ProfileSidebarAddress.js









var ProfileSidebarAddress = function(props) {
    var ref = (0,es/* useSelector */.v9)(store_company/* companySelector */.yX), addresses = ref.data.addresses;
    var isAuthenticated = (0,es/* useSelector */.v9)(store_auth/* authSelector */.aF).isAuthenticated;
    var handleAddAddress = props.handleAddAddress, handleEditAddress = props.handleEditAddress;
    var addressesItems;
    if (addresses && addresses.length > 0) {
        addressesItems = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ProfileSidebarAddress_module_default()).addressWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                    Tag: "h2",
                    variant: "eyebrow",
                    className: "mb-xs",
                    children: "Address"
                }),
                isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: addresses[0].fullAddress
                }) : // The API sends a logged-out visitor only the city.
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: (ProfileSidebarAddress_module_default()).locked,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": "true",
                            className: [
                                "loginBlur",
                                (ProfileSidebarAddress_module_default()).placeholder
                            ].join(" ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginInfo/* default */.Z, {
                            label: "Why is the address hidden?",
                            children: "The full address is shown to logged-in members."
                        })
                    ]
                })
            ]
        });
    } else {
        addressesItems = /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_AddContent/* default */.Z, {
            data: {
                direction: "column",
                label: "Add address",
                center: true,
                onClick: handleAddAddress
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ProfileSidebarAddress_module_default()).wrapper,
        children: [
            addressesItems,
            addresses && addresses.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileSidebarAddress_module_default()).edit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditContent/* default */.Z, {
                    data: {
                        style: "noLabel",
                        onClick: handleEditAddress
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Profile_ProfileSidebarAddress = (ProfileSidebarAddress);

// EXTERNAL MODULE: ./helpers/file.js + 1 modules
var file = __webpack_require__(30701);
;// CONCATENATED MODULE: ./components/Profile/ProfileSidebar.js












var ProfileSidebar = function(param) {
    var data = param.data;
    var dispatch = (0,es/* useDispatch */.I0)();
    var companyData = (0,es/* useSelector */.v9)(function(state) {
        return state.company.data;
    });
    var ref = (0,react.useState)(6), filesToShow = ref[0], setFilesToShow = ref[1];
    var filesRef = (0,react.useRef)(null);
    var auth = (0,es/* useSelector */.v9)(store_auth/* authSelector */.aF);
    var ref1 = (0,react.useState)(data.logo), logo = ref1[0], setLogo = ref1[1];
    var ref2 = (0,react.useState)(data.files), files = ref2[0], setFiles = ref2[1];
    (0,react.useEffect)(function() {
        setLogo(companyData.logo);
        setFiles(companyData.files);
    }, [
        companyData.logo,
        companyData.files
    ]);
    var handleAddFile = function() {
        dispatch((0,ux/* handleShowSidescreen */.Co)("add-file"));
    };
    var handleAddAddress = function() {
        dispatch((0,ux/* handleShowSidescreen */.Co)("add-address"));
    };
    var handleEditAddress = function() {
        dispatch((0,ux/* handleShowSidescreen */.Co)("edit-addresses"));
    };
    var handleEditInfo = function() {
        dispatch((0,ux/* handleShowSidescreen */.Co)("edit-info"));
    };
    var handleEditLogo = function() {
        dispatch((0,ux/* handleShowSidescreen */.Co)("edit-info"));
    };
    var logoSection = null;
    if (logo) {
        logoSection = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: logo.path,
                    alt: "".concat(data.name, " Logo")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProfileSidebar_module_default()).editLogoButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditContent/* default */.Z, {
                        data: {
                            label: "Edit logo",
                            onClick: handleEditLogo
                        }
                    })
                })
            ]
        });
    } else {
        logoSection = /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_AddContent/* default */.Z, {
            data: {
                direction: "column",
                label: auth.isJournalist ? "Add your photo" : "Add your logo or a picture",
                onClick: handleEditInfo
            }
        });
    }
    var handleWindowSize = function() {
        var maxItems = window.innerWidth < 375 ? 2 : window.innerWidth < 768 ? 3 : 6;
        setFilesToShow(maxItems);
    };
    var loaderTimeout;
    (0,react.useEffect)(function() {
        loaderTimeout = setTimeout(handleWindowSize, 410);
        if (true) {
            window.addEventListener("resize", handleWindowSize);
        }
        return function() {
            return clearTimeout(loaderTimeout);
        };
    });
    var filesSection;
    // todo: move to a separate file
    if (!files || files.length < 1) {
        var items = [];
        for(var i = 0; i < filesToShow - 1; i++){
            items.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "border-gray",
                    (ProfileSidebar_module_default()).filesItem,
                    (ProfileSidebar_module_default()).filesPlaceholder, 
                ].join(" ")
            }));
        }
        filesSection = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: [
                        "border-gray",
                        (ProfileSidebar_module_default()).filesItem
                    ].join(" "),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_AddContent/* default */.Z, {
                        data: {
                            direction: "column",
                            label: "Add file",
                            onClick: handleAddFile
                        }
                    })
                }),
                items.map(function(item, key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: item
                    }, "file-item-".concat(key));
                })
            ]
        });
    } else {
        var adder = null;
        var items1 = [];
        var moreFiles = files.length >= filesToShow;
        var maxItems = moreFiles ? filesToShow : filesToShow - 1;
        for(var i1 = 0; i1 < maxItems; i1++){
            if (files[i1]) {
                var overlay = null;
                if (i1 === filesToShow - 1 && filesToShow !== files.length) {
                    overlay = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProfileSidebar_module_default()).filesOverlay,
                        children: "+".concat(files.length - filesToShow)
                    });
                }
                var imageTypes = (0,file/* getImageTypes */.Vc)();
                var thisExt = (0,file/* getFileExtension */.mD)(files[i1].name);
                var isImage = imageTypes.includes(thisExt);
                var fileItem = null;
                if (isImage) {
                    fileItem = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            // 'border-gray',
                            (ProfileSidebar_module_default()).filesItem,
                            (ProfileSidebar_module_default()).filesBackground, 
                        ].join(" "),
                        style: {
                            background: "url(".concat(files[i1].path, ")")
                        },
                        onClick: handleAddFile,
                        children: overlay
                    });
                } else {
                    fileItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            "border-gray",
                            (ProfileSidebar_module_default()).filesItem
                        ].join(" "),
                        onClick: handleAddFile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProfileSidebar_module_default()).fileExtPreview,
                                children: (0,file/* getFileExtPreview */.Cp)(thisExt)
                            }),
                            overlay
                        ]
                    });
                }
                items1.push(fileItem);
            } else {
                items1.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: [
                        "border-gray",
                        (ProfileSidebar_module_default()).filesItem,
                        (ProfileSidebar_module_default()).filesPlaceholder, 
                    ].join(" ")
                }));
            }
        }
        if (!moreFiles) {
            adder = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "border-gray",
                    (ProfileSidebar_module_default()).filesItem
                ].join(" "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_AddContent/* default */.Z, {
                    data: {
                        direction: "column",
                        label: "Add file",
                        onClick: handleAddFile
                    }
                })
            });
        }
        filesSection = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                items1.map(function(item, key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: item
                    }, "file-item-".concat(key));
                }),
                adder
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ProfileSidebar_module_default()).sidebar,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: [
                    "border-gray",
                    (ProfileSidebar_module_default()).block,
                    (ProfileSidebar_module_default()).logo
                ].join(" "),
                children: logoSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: [
                    "border-gray",
                    (ProfileSidebar_module_default()).block,
                    (ProfileSidebar_module_default()).address
                ].join(" "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_ProfileSidebarAddress, {
                    handleAddAddress: handleAddAddress,
                    handleEditAddress: handleEditAddress
                })
            }),
            data.isJournalist === false && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (ProfileSidebar_module_default()).files,
                ref: filesRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                            Tag: "h3",
                            variant: "eyebrow",
                            className: (ProfileSidebar_module_default()).filesTitle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "data-nosnippet": true,
                                children: en/* profile.mediaPack.title */.N5._K.T
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProfileSidebar_module_default()).filesWrapper,
                        children: filesSection
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Profile_ProfileSidebar = (ProfileSidebar);

;// CONCATENATED MODULE: ./components/Profile/ProfileHeader.js





var ProfileHeader = function(props) {
    // todo: refactor ProfileSidebar and ProfileBio
    return(// Bio first in the DOM so the member's name is the first thing a crawler
    // reads; the sidebar is put back on the left visually with `order`.
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            "mb-l",
            (ProfileHeader_module_default()).profileHeader
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_ProfileBio, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_ProfileSidebar, (0,_object_spread/* default */.Z)({}, props))
        ]
    }));
};
/* harmony default export */ var Profile_ProfileHeader = (ProfileHeader);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./api/index.js + 49 modules
var api = __webpack_require__(46979);
// EXTERNAL MODULE: ./styles/modules/AlertNotificationsStatus.module.scss
var AlertNotificationsStatus_module = __webpack_require__(67737);
var AlertNotificationsStatus_module_default = /*#__PURE__*/__webpack_require__.n(AlertNotificationsStatus_module);
;// CONCATENATED MODULE: ./components/Profile/AlertNotificationsStatus.js










var AlertNotificationsStatus = function() {
    var ref = (0,es/* useSelector */.v9)(store_auth/* authSelector */.aF), id = ref.id, company = ref.company, isAuthenticated = ref.isAuthenticated, isJournalist = ref.isJournalist, deactivated = ref.deactivated, alertNotifications = ref.alertNotifications;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(false), saving = ref1[0], setSaving = ref1[1];
    var ref2 = (0,react.useState)(false), failed = ref2[0], setFailed = ref2[1];
    var isOwnPage = isAuthenticated && company === router.query.company;
    // undefined/null means /users/me never resolved. Showing OFF here is what
    // silently unsubscribed members in the first place.
    if (!isOwnPage || isJournalist || deactivated || alertNotifications === undefined || alertNotifications === null) {
        return null;
    }
    var isOn = Boolean(alertNotifications);
    var handleToggle = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var status, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSaving(true);
                        setFailed(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,api/* patchReq */.qn)("users/".concat(id, "/alert-notifications"), {
                                alertNotifications: !isOn
                            })
                        ];
                    case 2:
                        status = _state.sent().status;
                        if (status !== 200 && status !== 201) {
                            throw new Error("Unexpected status ".concat(status));
                        }
                        dispatch((0,store_auth/* setAuthDetails */.EQ)({
                            alertNotifications: !isOn
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setFailed(true);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setSaving(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleToggle() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            "mb-m",
            (AlertNotificationsStatus_module_default()).status,
            isOn ? (AlertNotificationsStatus_module_default()).on : (AlertNotificationsStatus_module_default()).off, 
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (AlertNotificationsStatus_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (AlertNotificationsStatus_module_default()).label,
                        children: [
                            "News Alerts: ",
                            isOn ? "ON" : "OFF"
                        ]
                    }),
                    !isOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (AlertNotificationsStatus_module_default()).message,
                        children: "You are not receiving News Alerts, so journalist requests for your expertise are passing you by."
                    }),
                    failed && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (AlertNotificationsStatus_module_default()).error,
                        children: "We could not change your News Alerts. Please try again."
                    })
                ]
            }),
            isOn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: handleToggle,
                disabled: saving,
                className: (AlertNotificationsStatus_module_default()).quietAction,
                children: "Turn off"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                title: "Turn News Alerts on",
                onClick: handleToggle,
                loading: saving,
                classes: [
                    (AlertNotificationsStatus_module_default()).action
                ]
            })
        ]
    });
};
/* harmony default export */ var Profile_AlertNotificationsStatus = (AlertNotificationsStatus);

// EXTERNAL MODULE: ./styles/modules/popUps/Alert.module.scss
var Alert_module = __webpack_require__(70688);
var Alert_module_default = /*#__PURE__*/__webpack_require__.n(Alert_module);
;// CONCATENATED MODULE: ./components/popUps/Alert.js



function Alert(props) {
    var isActive = props.isActive, alertMessage = props.alertMessage, onCancel = props.onCancel;
    // Hidden by opacity alone, so without this the "has been added" heading and
    // Continue button land in the server HTML of every page that mounts an Alert.
    if (!alertMessage) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            (Alert_module_default()).wrapper,
            isActive ? (Alert_module_default()).isActive : null
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Alert_module_default()).popUp,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                    className: (Alert_module_default()).title,
                    children: [
                        alertMessage,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "has been added"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                    title: "Continue",
                    onClick: onCancel
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/popUps/PaymentAlert.js



function PaymentAlert(props) {
    var isActive = props.isActive, alertTitle = props.alertTitle, alertMessage = props.alertMessage, onCancel = props.onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            (Alert_module_default()).wrapper,
            isActive ? (Alert_module_default()).isActive : null
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: [
                (Alert_module_default()).popUp
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: (Alert_module_default()).title,
                    children: alertTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: alertMessage
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                    title: "Continue",
                    onClick: onCancel
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./layouts/SidebarLayout.js + 2 modules
var SidebarLayout = __webpack_require__(22028);
// EXTERNAL MODULE: ./utils/safe-html.js
var safe_html = __webpack_require__(95460);
// EXTERNAL MODULE: ./styles/modules/BrokerDirectory.module.scss
var BrokerDirectory_module = __webpack_require__(41361);
var BrokerDirectory_module_default = /*#__PURE__*/__webpack_require__.n(BrokerDirectory_module);
// EXTERNAL MODULE: ./store/company/coverage.js
var coverage = __webpack_require__(57202);
// EXTERNAL MODULE: ./store/company/story.js
var story = __webpack_require__(69192);
// EXTERNAL MODULE: ./store/alert.js
var store_alert = __webpack_require__(74703);
// EXTERNAL MODULE: ./components/TitleUnderline.js
var TitleUnderline = __webpack_require__(46975);
// EXTERNAL MODULE: ./utils/alert-url.js
var alert_url = __webpack_require__(72247);
// EXTERNAL MODULE: ./utils/newsroom.js
var newsroom = __webpack_require__(93889);
// EXTERNAL MODULE: ./styles/modules/MediaCoverage.module.scss
var MediaCoverage_module = __webpack_require__(30730);
var MediaCoverage_module_default = /*#__PURE__*/__webpack_require__.n(MediaCoverage_module);
;// CONCATENATED MODULE: ./components/Profile/QuotedIn.js







function QuotedIn(param) {
    var items = param.items, total = param.total, companySlug = param.companySlug;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-l",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleUnderline/* default */.Z, {
                className: "mb-m",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                    Tag: "h2",
                    variant: "eyebrow",
                    children: "Quoted in"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (MediaCoverage_module_default()).quotedIn,
                children: items.map(function(story) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,alert_url/* alertPath */.E)(story.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: story.headline
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                dateTime: story.publishedAt,
                                children: (0,newsroom/* formatDate */.p6)(story.publishedAt)
                            })
                        ]
                    }, story.slug);
                })
            }),
            total > items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/news?profile=".concat(encodeURIComponent(companySlug)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (MediaCoverage_module_default()).viewAll,
                    children: [
                        "See all ",
                        total,
                        " stories"
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./utils/directory.js
var utils_directory = __webpack_require__(81455);
;// CONCATENATED MODULE: ./components/Directory/DirectoryBackLinks.js





// On a listed broker's profile: their town page and the topic pages they are on.
function DirectoryBackLinks(param) {
    var directory = param.directory;
    var ref = directory !== null && directory !== void 0 ? directory : {}, town = ref.town, _topics = ref.topics, topics = _topics === void 0 ? [] : _topics;
    if (!town && !topics.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: (BrokerDirectory_module_default()).backLinks,
        "aria-label": "Mortgage broker directory",
        children: [
            town && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: (0,utils_directory/* townPath */.OY)(town.slug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        children: [
                            "More mortgage brokers in ",
                            town.name
                        ]
                    })
                })
            }),
            topics.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Also quoted on:",
                    " ",
                    topics.map(function(topic, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                index > 0 && ", ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (0,utils_directory/* topicPath */.KL)(topic.slug, topic.underTopic),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: (0,utils_directory/* topicLabel */.mP)(topic.name)
                                    })
                                })
                            ]
                        }, topic.slug);
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Directory/DirectoryBreadcrumb.js
var DirectoryBreadcrumb = __webpack_require__(72936);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./pages/[company]/index.js




























var Sidescreen = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2283), __webpack_require__.e(9747), __webpack_require__.e(1345), __webpack_require__.e(6266), __webpack_require__.e(7665)]).then(__webpack_require__.bind(__webpack_require__, 6266));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6266)
            ];
        }
    },
    ssr: false
});
var JournalistProfile = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3773).then(__webpack_require__.bind(__webpack_require__, 73773));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73773)
            ];
        }
    },
    ssr: false
});
var CompanyPremiumBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2737).then(__webpack_require__.bind(__webpack_require__, 2737));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2737)
            ];
        }
    },
    ssr: false
});
// Server-rendered on purpose: this is the Media Coverage section, and it is the
// only substantial indexable text on a profile. The other dynamic imports below
// stay client-only.
var NewspagerProfile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5050), __webpack_require__.e(2649)]).then(__webpack_require__.bind(__webpack_require__, 64684));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64684)
            ];
        }
    }
});
var ContactsBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9420).then(__webpack_require__.bind(__webpack_require__, 69420));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69420)
            ];
        }
    },
    ssr: false
});
var FcaAdminPanel = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1223), __webpack_require__.e(5025)]).then(__webpack_require__.bind(__webpack_require__, 44790));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44790)
            ];
        }
    },
    ssr: false
});
var DirectoryAdminPanel = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 20).then(__webpack_require__.bind(__webpack_require__, 50020));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50020)
            ];
        }
    },
    ssr: false
});
var DeactivateAdminPanel = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 102).then(__webpack_require__.bind(__webpack_require__, 30102));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30102)
            ];
        }
    },
    ssr: false
});
var DirectoryExcludedBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 20).then(__webpack_require__.bind(__webpack_require__, 50020)).then(function(mod) {
        return mod.DirectoryExcludedBanner;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50020)
            ];
        }
    },
    ssr: false
});
var Index = function(props) {
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(false), alert = ref1[0], setAlert = ref1[1];
    var ref2 = (0,react.useState)(false), showSuccessAlert = ref2[0], setShowSuccessAlert = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(store_company/* companySelector */.yX), company = ref3.data;
    var ref4 = (0,es/* useSelector */.v9)(coverage/* coveragesSelector */.NQ), coverages = ref4.data, coveragesTotal = ref4.total;
    var ref5 = (0,es/* useSelector */.v9)(story/* storiesSelector */.A9), stories = ref5.data;
    var ref6 = (0,es/* useSelector */.v9)(store_alert/* alertSelector */.wV), alerts = ref6.data;
    var sidescreen = (0,es/* useSelector */.v9)(ux/* uxSelector */.sN).sidescreen;
    var ref7 = (0,es/* useSelector */.v9)(store_auth/* authSelector */.aF), isAuthenticated = ref7.isAuthenticated, isJournalist = ref7.isJournalist, isAdmin = ref7.isAdmin;
    var store = (0,es/* useStore */.oR)();
    var plan = company === null || company === void 0 ? void 0 : company.plan;
    var ref8 = (0,react.useState)(false), showPremiumBanner = ref8[0], setShowPremiumBanner = ref8[1];
    var ref9 = (0,react.useState)(null), directoryStatus = ref9[0], setDirectoryStatus = ref9[1];
    var router = (0,next_router.useRouter)();
    var isUserJournalist = isJournalist;
    // The page is cached HTML built without a user, so everything that depends
    // on who is looking is resolved here instead of in getStaticProps.
    (0,react.useEffect)(function() {
        if (!isAuthenticated) {
            return;
        }
        dispatch((0,store_auth/* handleAuthorization */.fy)(router.query.company));
        if (!store.getState().auth.isAdmin) {
            dispatch((0,store_alert/* fetchAlerts */.QK)());
        }
        // The cached page carries no email or phone; a member gets them for Get in touch.
        (0,api/* getReq */.ZL)("/profiles/slug/".concat(router.query.company)).then(function(param) {
            var data = param.data;
            var ref;
            if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.id) {
                dispatch(store_company/* fetchCompanyBySlug.fulfilled */._g.fulfilled(data.data));
            }
        }).catch(function() {});
    }, [
        isAuthenticated,
        router.query.company
    ]);
    (0,react.useEffect)(function() {
        if (router.query.showPremiumBanner != 1) {
            return;
        }
        setShowPremiumBanner(true);
        setTimeout(function() {
            setShowPremiumBanner(false);
        }, 10000);
    }, []);
    // Check for successful response purchase on page load
    (0,react.useEffect)(function() {
        var purchaseInProgress = localStorage.getItem("responsePurchaseInProgress");
        if (purchaseInProgress === "true") {
            setShowSuccessAlert(true);
            localStorage.removeItem("responsePurchaseInProgress");
            localStorage.removeItem("responsePurchaseQuantity");
        }
    }, []);
    var showJournalistProfile = company.name === "" || company.publication === "" && company.isAuthenticated;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default */.Z, props.seo), {
                titleTemplate: "%s",
                openGraph: (0,_object_spread/* default */.Z)({}, next_seo_config/* default.openGraph */.Z.openGraph, (ref = props.seo) === null || ref === void 0 ? void 0 : ref.openGraph)
            })),
            props.schema && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0,safe_html/* jsonLd */.oL)(props.schema)
                }
            }),
            props.directoryCrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0,safe_html/* jsonLd */.oL)((0,utils_directory/* profileBreadcrumbSchema */.mu)(props.directoryCrumbs, "https://app.newspage.media"))
                }
            }),
            showPremiumBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPremiumBanner, {
                setShowPremiumBanner: setShowPremiumBanner,
                plan: plan
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarLayout/* default */.Z, {
                isAuthenticated: isAuthenticated,
                children: [
                    isUserJournalist && showJournalistProfile && /*#__PURE__*/ (0,jsx_runtime.jsx)(JournalistProfile, {
                        name: company.name,
                        publication: company.publication,
                        website: company.website,
                        addresses: company.addresses
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                        isActive: alert,
                        alertMessage: alert,
                        onCancel: function() {
                            setAlert(false);
                        }
                    }),
                    !isUserJournalist && /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_AlertNotificationsStatus, {}),
                    props.directoryCrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BrokerDirectory_module_default()).profileBreadcrumb,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryBreadcrumb/* default */.Z, {
                            items: props.directoryCrumbs
                        })
                    }),
                    isAdmin === true && (directoryStatus === null || directoryStatus === void 0 ? void 0 : directoryStatus.excluded) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryExcludedBanner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_ProfileHeader, {
                        data: company,
                        coverageClaim: props.coverageClaim,
                        aboutWithCount: props.aboutWithCount
                    }),
                    isAdmin === true && company.id && !company.isJournalist && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FcaAdminPanel, {
                                profile: company
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryAdminPanel, {
                                profile: company,
                                onStatus: setDirectoryStatus
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivateAdminPanel, {
                                profile: company
                            })
                        ]
                    }),
                    !isUserJournalist && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewspagerProfile, {
                                company: company,
                                coverages: coverages,
                                coveragesTotal: coveragesTotal,
                                stories: stories,
                                alerts: alerts,
                                news_stories: en/* profile.news_stories */.N5.c0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotedIn, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.quotedIn), {
                                companySlug: company.slug
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryBackLinks, {
                                directory: props.directory
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsBanner, {
                                title: en/* profile.contact.title */.N5.PX.T
                            })
                        ]
                    }),
                    (sidescreen === null || sidescreen === void 0 ? void 0 : sidescreen.active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen, {
                        onUpdate: function(val) {
                            dispatch((0,ux/* handleHideSidescreen */.Qb)());
                            setAlert(val);
                        }
                    })
                ]
            }),
            showSuccessAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentAlert, {
                isActive: true,
                alertTitle: "Payment Successful!",
                alertMessage: "Thank you for your purchase. Your responses have been added to your account.",
                onCancel: function() {
                    setShowSuccessAlert(false);
                }
            })
        ]
    });
};
var __N_SSG = true;
// No wrapper.withRedux here — _app.js already wraps the tree. Double-wrapping
// gives this page a second store that never receives HYDRATE, so everything
// rendered from useSelector comes out empty server-side.
/* harmony default export */ var _company_ = (Index);


/***/ }),

/***/ 68545:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var pluralize = function(count, noun) {
    var suffix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "s";
    return "".concat(noun).concat(count !== 1 ? suffix : "");
};
/* harmony default export */ __webpack_exports__["Z"] = (pluralize);


/***/ }),

/***/ 67737:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"status":"AlertNotificationsStatus_status__UetDx","off":"AlertNotificationsStatus_off__EyrXx","on":"AlertNotificationsStatus_on__znF_4","body":"AlertNotificationsStatus_body__8kmuv","label":"AlertNotificationsStatus_label__7nbAu","message":"AlertNotificationsStatus_message__qYI3L","error":"AlertNotificationsStatus_error__GwuRZ","action":"AlertNotificationsStatus_action__6uWLm","quietAction":"AlertNotificationsStatus_quietAction__WMJM8"};

/***/ }),

/***/ 41361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrokerDirectory_wrapper__9A1ta","breadcrumb":"BrokerDirectory_breadcrumb__WIe7D","head":"BrokerDirectory_head__vKpDv","intro":"BrokerDirectory_intro__DnKBF","notes":"BrokerDirectory_notes__pEIrE","listingsLine":"BrokerDirectory_listingsLine__u1VFj","updated":"BrokerDirectory_updated__C37Mq","sectionTitle":"BrokerDirectory_sectionTitle__oQ8wO","list":"BrokerDirectory_list__4UYgo","card":"BrokerDirectory_card__bBMG3","cardHead":"BrokerDirectory_cardHead__UFkQG","name":"BrokerDirectory_name__o_3wy","verified":"BrokerDirectory_verified__6pCWh","fca":"BrokerDirectory_fca__FCc_1","meta":"BrokerDirectory_meta__UYkQ6","count":"BrokerDirectory_count__bADm4","item":"BrokerDirectory_item__DvjD0","itemLabel":"BrokerDirectory_itemLabel__FHi1w","outlet":"BrokerDirectory_outlet__1Y78C","date":"BrokerDirectory_date__oUy18","stories":"BrokerDirectory_stories__Ya4U0","topics":"BrokerDirectory_topics__2__so","topicName":"BrokerDirectory_topicName__AVY4S","topicCount":"BrokerDirectory_topicCount__Yc_Eh","pendingNote":"BrokerDirectory_pendingNote__zdU_6","pending":"BrokerDirectory_pending__lnH70","letters":"BrokerDirectory_letters__x2FEf","letter":"BrokerDirectory_letter__MNl8u","letterTown":"BrokerDirectory_letterTown__CF0jX","backLink":"BrokerDirectory_backLink__B2BBM","empty":"BrokerDirectory_empty__PtR3W","backLinks":"BrokerDirectory_backLinks__hriP_","profileBreadcrumb":"BrokerDirectory_profileBreadcrumb__tmaA5","folded":"BrokerDirectory_folded__NTyx2","moreItems":"BrokerDirectory_moreItems__UIej1","showMore":"BrokerDirectory_showMore__VbWYa"};

/***/ }),

/***/ 30909:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info":"LoginInfo_info__pg7Eb","popover":"LoginInfo_popover__B10QS"};

/***/ }),

/***/ 30730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newCoverageNotification":"MediaCoverage_newCoverageNotification__rRUej","mediaCoverage":"MediaCoverage_mediaCoverage__3hhp0","addBtnWrapper":"MediaCoverage_addBtnWrapper__D9YDy","tellUs":"MediaCoverage_tellUs__c_Vxj","viewAll":"MediaCoverage_viewAll__y3v4y","quotedIn":"MediaCoverage_quotedIn__5jUku"};

/***/ }),

/***/ 53609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contacts":"ProfileBio_contacts__1Nq_w","bio":"ProfileBio_bio__swtsh","header":"ProfileBio_header__oLOWP","headerContent":"ProfileBio_headerContent__n0TYY","badges":"ProfileBio_badges__A9uKF","badge":"ProfileBio_badge__T6vWl","badgeEditor":"ProfileBio_badgeEditor__7zAWc","badgePlatinum":"ProfileBio_badgePlatinum__md7jG","badgePremium":"ProfileBio_badgePremium__f6ERF","badgeLegend":"ProfileBio_badgeLegend__hKjI7","badgeFTEditor":"ProfileBio_badgeFTEditor__mlNAA","badgeAdmin":"ProfileBio_badgeAdmin__NhJUH","badgeJournalist":"ProfileBio_badgeJournalist__tn_Gd","badgeVerified":"ProfileBio_badgeVerified__7yHRH","badgeFca":"ProfileBio_badgeFca__nxrAa","fcaEvidence":"ProfileBio_fcaEvidence__7JcyS","creditsSection":"ProfileBio_creditsSection__WFLG4","fullHeader":"ProfileBio_fullHeader__Yp7lk","title":"ProfileBio_title__5tBt2","mediaTitle":"ProfileBio_mediaTitle__IQNUM","description":"ProfileBio_description__s999B","contactsWebsite":"ProfileBio_contactsWebsite__B0U2w","contactsIcon":"ProfileBio_contactsIcon__lDIbH","contactsSocial":"ProfileBio_contactsSocial__8sCxJ","addTag":"ProfileBio_addTag__d_5dQ","dropdown":"ProfileBio_dropdown__ZeIL0","add":"ProfileBio_add__XgTxD","empty":"ProfileBio_empty__5UT29","addTagActive":"ProfileBio_addTagActive__V8D0v","loadMore":"ProfileBio_loadMore__Hf0Mq","lists":"ProfileBio_lists__sqxIW","list":"ProfileBio_list__KBREa","listOneRow":"ProfileBio_listOneRow__ZYmDx","tagRow":"ProfileBio_tagRow__hKTTZ","tagRowList":"ProfileBio_tagRowList__Ue1iA","tagRowExpanded":"ProfileBio_tagRowExpanded__Juv9i","listExperts":"ProfileBio_listExperts__rOmrj","smart":"ProfileBio_smart__fKOcm","premium":"ProfileBio_premium__tz4AJ","premiumText":"ProfileBio_premiumText__KAVhL","icon":"ProfileBio_icon__NGR9b","listTitle":"ProfileBio_listTitle__DU6Ys","position":"ProfileBio_position__wyF8s","employer":"ProfileBio_employer__b8wYu","coverageClaim":"ProfileBio_coverageClaim__sx4FY","coverageClaimUnderName":"ProfileBio_coverageClaimUnderName__VLuYJ"};

/***/ }),

/***/ 52987:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileHeader":"ProfileHeader_profileHeader__j4LpV"};

/***/ }),

/***/ 7878:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"ProfileSidebar_sidebar__6No4D","block":"ProfileSidebar_block__6cqnR","blockEmpty":"ProfileSidebar_blockEmpty__ku9yJ","logo":"ProfileSidebar_logo__QVWRA","editLogoButton":"ProfileSidebar_editLogoButton__GcYgn","address":"ProfileSidebar_address__wjATC","files":"ProfileSidebar_files__BUEvD","filesTitle":"ProfileSidebar_filesTitle__ygKAX","filesWrapper":"ProfileSidebar_filesWrapper__TT5_b","filesItem":"ProfileSidebar_filesItem__azQpO","filesPlaceholder":"ProfileSidebar_filesPlaceholder__3XoWm","filesBackground":"ProfileSidebar_filesBackground__iriQP","filesOverlay":"ProfileSidebar_filesOverlay__Tchhn","fileExtPreview":"ProfileSidebar_fileExtPreview__oE1_a"};

/***/ }),

/***/ 72436:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileSidebarAddress_wrapper__oK8Kn","slider":"ProfileSidebarAddress_slider__FLdWU","image":"ProfileSidebarAddress_image__v0tK8","body":"ProfileSidebarAddress_body__ZemZv","address":"ProfileSidebarAddress_address__1KTRR","edit":"ProfileSidebarAddress_edit__GlhM3","addressWrapper":"ProfileSidebarAddress_addressWrapper__KEj0w","locked":"ProfileSidebarAddress_locked__LjgEw","placeholder":"ProfileSidebarAddress_placeholder__4dAYQ"};

/***/ }),

/***/ 89073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"descriptionText":"SmartText_descriptionText__p8r17","data":"SmartText_data__hd0hx","doubleQuoted":"SmartText_doubleQuoted__0PrJE","shadow":"SmartText_shadow__vEDiH","shadowOpened":"SmartText_shadowOpened__CCLQd","link":"SmartText_link__5KakI","opened":"SmartText_opened__xpCyI"};

/***/ }),

/***/ 23619:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleUnderline_title__cX4eL"};

/***/ }),

/***/ 70688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Alert_wrapper__eJTjm","isActive":"Alert_isActive__VLjDh","popUp":"Alert_popUp__DaV80","title":"Alert_title__N9Omm","cancelButton":"Alert_cancelButton__ZpPaz"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1036,9258,2017,8300,1455,355,9774,2888,179], function() { return __webpack_exec__(37555); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);